import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import JSEncrypt from "jsencrypt";
import forge from "node-forge";
import ForgotPasswordForm from "./ForgotPasswordForm"; // Assuming you have this component

const LoginForm = () => {
	const navigate = useNavigate();
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [loading, setLoading] = useState(false); // New state for loading
	const [showForgotPassword, setShowForgotPassword] = useState(false); // State to toggle forms

	const encryptPassword = async (password) => {
		try {
			// Fetch public key
			const res = await fetch("https://parallex.approot.ng/get_public_key.php");
			const pem = await res.text();

			// Convert PEM to Forge public key
			const publicKey = forge.pki.publicKeyFromPem(pem);

			// Encrypt using OAEP padding
			const encrypted = publicKey.encrypt(password, "RSA-OAEP", {
				md: forge.md.sha1.create(),
			});

			// Return base64-encoded string
			return window.btoa(encrypted);
		} catch (error) {
			console.error("Encryption failed:", error);
			throw error;
		}
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);

		try {
			const encryptedPassword = await encryptPassword(password);

			const response = await axios.post(
				"https://parallex.approot.ng/login.php",
				{
					email,
					password: encryptedPassword,
				}
			);

			if (response.data.status || response.data.success === "success") {
				toast.success("Successfully sent OTP to user");
				sessionStorage.setItem("token", response.data.token);
				localStorage.setItem("email", email);
				navigate("/otp");
			} else {
				toast.error(response.data.message || "Invalid credentials.");
			}
		} catch (error) {
			console.error("Login error:", error);
			toast.error("Encryption or login failed.");
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		const token = localStorage.getItem("token");
		if (token) {
			navigate("/dashboard", { replace: true });
		}
	}, [navigate]);

	return (
		<div className='min-h-screen flex items-center justify-center bg-gray-100 font-inter'>
			<div className='max-w-md w-full bg-white p-8 rounded-lg shadow-lg'>
				<div>
					<h2 className='text-3xl font-semibold text-center text-red-600 mb-6'>
						SMS Portal Login
					</h2>

					<form onSubmit={handleSubmit} className='space-y-6'>
						<div>
							<label
								htmlFor='email'
								className='block text-gray-700 font-medium'
							>
								Email
							</label>
							<input
								type='email'
								id='email'
								value={email}
								onChange={(e) => setEmail(e.target.value)}
								className='w-full p-3 mt-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500'
								required
							/>
						</div>

						<div>
							<label
								htmlFor='password'
								className='block text-gray-700 font-medium'
							>
								Password
							</label>
							<input
								type='password'
								id='password'
								value={password}
								onChange={(e) => setPassword(e.target.value)}
								className='w-full p-3 mt-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500'
								required
							/>
						</div>

						<button
							type='submit'
							disabled={loading}
							className='w-full py-3 mt-4 bg-red-600 text-white font-semibold rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 disabled:opacity-50 disabled:cursor-not-allowed'
						>
							{loading ? "Signing In..." : "Sign In"}{" "}
							{/* Change text based on loading state */}
						</button>
					</form>

					<div className='mt-4 text-center'>
						<a
							// onClick={() => setShowForgotPassword(true)}
							className='text-sm text-red-600 hover:underline bg-transparent border-none cursor-pointer p-0'
							href='/forgot-password'
						>
							Forgot Password?
						</a>
					</div>
				</div>
			</div>
		</div>
	);
};

export default LoginForm;
